<template>
  <div class="row m-0">
    <div v-if="!canLoad" class="map-placeholder d-flex flex-column align-items-center justify-content-center w-100">
      <div class="text-center px-3">
        <h5 class="mb-2">Žemėlapis</h5>
        <p v-if="!missingApiKey" class="text-muted mb-3">
          Norint matyti „Google Maps“, reikia sutikimo trečiųjų šalių turiniui.
        </p>
        <p v-else class="text-muted mb-3">
          Žemėlapis laikinai nepasiekiamas, nes nėra sukonfigūruotas „Google Maps“ API raktas.
        </p>
        <button
          v-if="!missingApiKey"
          class="btn btn-danger btn-sm"
          @click="allowExternal"
        >
          Leisti „Google Maps“
        </button>
      </div>
    </div>
    <GoogleMap
      v-else
      :api-key="apiKey"
      style="width: 100%; height: 500px"
      :center="center"
      :zoom="15"
    >
      <Marker :options="{ position: center }" />
    </GoogleMap>
  </div>
</template>

<script>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { GoogleMap, Marker } from 'vue3-google-map'
import { getConsent, onConsentChange, setConsent } from '@/utils/consent'

export default {
  name: "Map",
  components: {
    GoogleMap,
    Marker
  },
  setup() {
    const center = { lat: 54.6013, lng: 24.16123 }
    const apiKey = process.env.VUE_APP_GOOGLE_MAPS_API_KEY || ''
    const consent = ref(getConsent())
    let unsubscribe = null

    const missingApiKey = computed(() => !apiKey)
    const canLoad = computed(() => {
      return !!apiKey && consent.value && consent.value.external === true
    })

    const allowExternal = () => {
      const newConsent = setConsent({ external: true })
      consent.value = newConsent
    }

    onMounted(() => {
      unsubscribe = onConsentChange((c) => {
        consent.value = c
      })
    })

    onBeforeUnmount(() => {
      if (unsubscribe) unsubscribe()
    })

    return {
      center,
      apiKey,
      consent,
      canLoad,
      missingApiKey,
      allowExternal
    }
  }
}
</script>

<style scoped>
.row {
  margin: 0;
}

.map-placeholder {
  height: 500px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-top: 1px solid rgba(0,0,0,0.05);
  border-bottom: 1px solid rgba(0,0,0,0.05);
}

.map-placeholder h5 {
  font-family: 'Montserrat', sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 12px;
}

.map-placeholder p {
  font-family: 'Open Sans', sans-serif;
  font-size: 0.95rem;
  color: #6c757d;
}

.map-placeholder .btn-danger {
  background: linear-gradient(135deg, #dc3545, #ff6b6b);
  border: none;
  border-radius: 8px;
  padding: 10px 24px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.map-placeholder .btn-danger:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(220, 53, 69, 0.4);
}

:deep(.vue-map-container) {
  border-radius: 0;
}
</style>